import families from '@/services/api/families';
import upload from '@/services/api/upload';

export default {
    namespaced: true,
    state: {
        family: null,
        isCurrentEdition: false,
        consentLink: null
    },
    getters: {
        getFamily (state) {
            return state.family;
        },
        isCurrentEdition: (state) => state.isCurrentEdition,
        getConsentLink: (state) => state.consentLink
    },
    mutations: {
        setFamily (state, data) {
            state.family = data;
        },
        setIsCurrentEdition (state, data) {
            state.isCurrentEdition = data;
        },
        setConsentLink (state, data) {
            state.consentLink = data;
        }
    },
    actions: {
        getFamily (context, payload) {
            return families.getFamilyById(payload.id, payload.endpointLabel).then(({ data }) => {
                context.commit('setFamily', data.data);
                if (data.data.edition) {
                    context.commit('setIsCurrentEdition', data.data.edition.current);
                }
                return data;
            });
        },
        turnOffFamily (context, payload) {
            return families.excludeFamily(payload);
        },
        turnOnFamily (context, payload) {
            return families.includeFamily(payload);
        },
        changeRegion (context, payload) {
            return families.putChangeRegion(payload);
        },
        revokeFamily (context, id) {
            return families.revokeFamily(id).then((data) => {
                context.commit('setFamily', data.data);
            });
        },
        getFamilyEditionConsentUri (context, data) {
            context.commit('setConsentLink', upload.getFamilyEditionConsentUri(data));
        },
        editFamilyDescription (context, data) {
            return families.editFamilyDescription(data).then((data) => {
                context.commit('setFamily', data.data.data);
            });
        }
    }
};
